import { tTypeAttachment } from '../../MessageBubble.type.ts';
import { PhoneIcon } from '@heroicons/react/24/outline';
import './ContactContent.styles.scss';

export default function ContactContent(props: tTypeAttachment) {
  if (!props?.attachment?.vcard) {
    return null;
  }

  // Capture everything after the colon on any TEL line (multiline, case-insensitive).
  // Handles all standard vcard formats including ChatDaddy/Baileys item-prefixed properties:
  //   TEL;TYPE=CELL:+521234567890
  //   TEL;type=CELL;type=VOICE;waid=521234567890:+52 1 447 123 4567
  //   TEL:+1 (234) 567-8901
  //   item1.TEL;waid=5215574488373:+52 55 7448 8373
  const telMatch = props.attachment.vcard.match(/^(?:item\d+\.)?TEL[^:]*:(.+)$/im);
  const phone = telMatch ? telMatch[1].trim() : null;

  if (!phone) {
    return null;
  }

  return (
    <div className="ContactContent">
      <a
        href={`tel:${phone.replace(/[^\d+]/g, '')}`}
        className="ContactContent__link"
      >
        <PhoneIcon className="ContactContent__link__icon" />
        {phone}
      </a>
    </div>
  );
}
